module.exports = __webpack_public_path__ + "static/media/stand@2x.64502167.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/stand@2x.png
// module id = 1120
// module chunks = 0